import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-download',
    templateUrl: './download.component.svg',
    styleUrls: ['./download.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadComponent {}
